import { NgModule } from '@angular/core';
import { AgeTypeNamePipe } from './ageTypeName.pipe';
import { DateTimePipe } from './date-time.pipe';
import { DatePipe } from './date.pipe';
import { EuroPipe } from './euro.pipe';
import { FondsFilterPipe } from './fonds-filter.pipe';
import { FooterLinksValuePipe } from './footer-links-value.pipe';
import { FractionPipe } from './fraction.pipe';
import { IbanPipe } from './iban.pipe';
import { LabelTextPipe } from './label-text.pipe';
import { PerformanceFractionPipe } from './performance-fraction.pipe';
import { PerformanceRangePipe } from './performance-range.pipe';
import { PerformanceYearPipe } from './performance-year.pipe';
import { PerformancePipe } from './performance.pipe';
import { PhoneAsterisksPipe } from './phone-asterisks.pipe';
import { RangePipe } from './range.pipe';
import { RoundTo2DecimalPipe } from './roundTo2Decimal.pipe';
import { SafeHtml } from './safe-html.pipe';
import { WithdrawalTypePipe } from './withdrawalType.pipe';
import { YesNoPipe } from './yesNo.pipe';

@NgModule({
  declarations: [
    LabelTextPipe,
    EuroPipe,
    IbanPipe,
    FondsFilterPipe,
    SafeHtml,
    PerformancePipe,
    FractionPipe,
    RoundTo2DecimalPipe,
    DatePipe,
    DateTimePipe,
    RangePipe,
    FooterLinksValuePipe,
    YesNoPipe,
    AgeTypeNamePipe,
    WithdrawalTypePipe,
    PerformanceYearPipe,
    PhoneAsterisksPipe,
    PerformanceFractionPipe,
    PerformanceRangePipe
  ],
  imports: [],
  exports: [
    LabelTextPipe,
    EuroPipe,
    IbanPipe,
    FondsFilterPipe,
    SafeHtml,
    PerformancePipe,
    FractionPipe,
    RoundTo2DecimalPipe,
    DatePipe,
    DateTimePipe,
    RangePipe,
    FooterLinksValuePipe,
    YesNoPipe,
    AgeTypeNamePipe,
    WithdrawalTypePipe,
    PerformanceYearPipe,
    PhoneAsterisksPipe,
    PerformanceFractionPipe,
    PerformanceRangePipe
  ],
  providers: [EuroPipe, PerformancePipe, LabelTextPipe, FractionPipe]
})
export class PipesModule {}
